import React, { useState, useRef } from 'react';
import Slider from 'react-slick';

import { textSettings, MAIN_TEXT_RUN, LINEUP } from './constants';
import './BodySquidGame.scss';

export const BodySquidGame = ({ baseImgUrl }) => {
  const [stateYongHee, setStateYongHee] = useState({
    currentKey: 'C1',
    colors: LINEUP[0].product.colors,
  });
  const [stateStaircase, setStateStaircase] = useState({
    currentKey: 'C1',
    colors: LINEUP[1].product.colors,
  });
  const [stateFrontman, setStateFrontman] = useState({
    currentKey: 'C1',
    colors: LINEUP[2].product.colors,
  });
  const [stateTrackSuit, setStateTrackSuit] = useState({
    currentKey: 'C1',
    colors: LINEUP[3].product.colors,
  });
  const [statePiggyBank, setStatePiggyBank] = useState({
    currentKey: 'C1',
    colors: LINEUP[4].product.colors,
  });
  const [stateOx, setStateOx] = useState({
    currentKey: 'C1',
    colors: LINEUP[5].product.colors,
  });

  const refYongHee = useRef(null);
  const refStaircase = useRef(null);
  const refFrontman = useRef(null);
  const refTrackSuit = useRef(null);
  const refPiggyBank = useRef(null);
  const refOx = useRef(null);

  const mainProductSetting = {
    infinite: true,
    dots: false,
    arrows: false,
    speed: 800,
    slidesToShow: 1,
    autoplay: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          autoplay: true,
        },
      },
      {
        breakpoint: 9999,
        settings: {
          slidesToShow: 2,
          autoplay: false,
        },
      },
    ],
  };

  const pointSetting = {
    infinite: true,
    dots: true,
    speed: 500,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 9999,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  const productSetting = {
    infinite: true,
    dots: false,
    speed: 500,
    arrows: true,
    centerMode: true,
    variableWidth: true,
  };

  const yongHeeSetting = {
    ...productSetting,
    afterChange: async current => {
      await Promise.all([setStateYongHee(prev => ({ ...prev }))]);
    },
  };

  const staircaseSetting = {
    ...productSetting,
    afterChange: async current => {
      await Promise.all([setStateStaircase(prev => ({ ...prev }))]);
    },
  };

  const frontmanSetting = {
    ...productSetting,
    afterChange: async current => {
      await Promise.all([setStateFrontman(prev => ({ ...prev }))]);
    },
  };

  const trackSuitSetting = {
    ...productSetting,
    afterChange: async current => {
      await Promise.all([setStateTrackSuit(prev => ({ ...prev }))]);
    },
  };

  const piggyBankSetting = {
    ...productSetting,
    afterChange: async current => {
      await Promise.all([setStatePiggyBank(prev => ({ ...prev }))]);
    },
  };

  const oxSetting = {
    ...productSetting,
    afterChange: async current => {
      await Promise.all([setStateOx(prev => ({ ...prev }))]);
    },
  };

  const productMap = {
    'SG1002X-5S': {
      setting: yongHeeSetting,
      ref: refYongHee,
      limit: LINEUP[0].product.limit,
      currentKey: stateYongHee.currentKey,
      stateProduct: stateYongHee,
      setState: setStateYongHee,
    },
    'SG2002N-5S': {
      setting: staircaseSetting,
      ref: refStaircase,
      limit: LINEUP[1].product.limit,
      currentKey: stateStaircase.currentKey,
      stateProduct: stateStaircase,
      setState: setStateStaircase,
    },
    'SG2001G-5S': {
      setting: frontmanSetting,
      ref: refFrontman,
      limit: LINEUP[2].product.limit,
      currentKey: stateFrontman.currentKey,
      stateProduct: stateFrontman,
      setState: setStateFrontman,
    },
    'SG1001X-5S': {
      setting: trackSuitSetting,
      ref: refTrackSuit,
      limit: LINEUP[3].product.limit,
      currentKey: stateTrackSuit.currentKey,
      stateProduct: stateTrackSuit,
      setState: setStateTrackSuit,
    },
    'SG1003G-5S': {
      setting: piggyBankSetting,
      ref: refPiggyBank,
      limit: LINEUP[4].product.limit,
      currentKey: statePiggyBank.currentKey,
      stateProduct: statePiggyBank,
      setState: setStatePiggyBank,
    },
    'SG2003G-5S': {
      setting: oxSetting,
      ref: refOx,
      limit: LINEUP[5].product.limit,
      currentKey: stateOx.currentKey,
      stateProduct: stateOx,
      setState: setStateOx,
    },
  };

  const isSelectedColor = (currentKey, index) => {
    const selectedColorMap = {
      0: ['C1'],
      1: ['C2'],
    };
    return selectedColorMap[index]?.includes(currentKey) || false;
  };

  const handleSelectedColor = (productNumber, index) => {
    if (productMap[productNumber]) {
      const { setState } = productMap[productNumber];
      const productColorKeyMap = {
        'SG1002X-5S': ['C1', 'C2'],
        'SG2002N-5S': ['C1', 'C2'],
        'SG2001G-5S': ['C1', 'C2'],
        'SG1001X-5S': ['C1', 'C2'],
        'SG1003G-5S': ['C1', 'C2'],
        'SG2003G-5S': ['C1', 'C2'],
      };

      const colorKeys = productColorKeyMap[productNumber];
      const newCurrentKey = colorKeys?.[index] || null;

      setState(prev => ({
        ...prev,
        currentKey: newCurrentKey,
      }));
    }
  };

  const renderName = (id, title) => {
    return (
      <div className="body-squid-game__lineup__model-main-name" data-aos="fade-up" data-key={id}>
        <h3>
          <strong>{title}</strong>
          <small>MODEL</small>
        </h3>

        <div className="base-squid-game__text-run" data-section="lineup">
          <Slider {...textSettings} className="base-squid-game__text-run__list">
            {Array.from({ length: 10 })
              .flatMap(() => MAIN_TEXT_RUN)
              .map((text, index) => (
                <div key={index}>
                  <li>{text}</li>
                </div>
              ))}
          </Slider>
        </div>
      </div>
    );
  };

  const renderButton = (productNumber, currentKey) => {
    return (
      <a
        className="base-squid-game__btn base-squid-game__btn--pink"
        href={`/sg/en/squid-game-${productNumber.toLowerCase()}-${currentKey.toLowerCase()}-eyeglasses.html`}
      >
        ONLINE STORE
      </a>
    );
  };

  const renderModel = ({ title, product, desc, points }) => {
    const id = title.toLowerCase().replace(' ', '-');
    const productPath = `${baseImgUrl}/lineup/products/${product.number}`;
    const { limit, currentKey, stateProduct, setting, ref } = productMap[product.number];

    return (
      <div className="body-squid-game__lineup__wrapper" id={id}>
        <div className="body-squid-game__lineup__model">
          <div className="body-squid-game__lineup__model-main">
            <picture className="body-squid-game__lineup__model-main-bg">
              <source media="(min-width: 768px)" srcSet={`${productPath}/main-bg_pc.webp`} />
              <img alt={`${title} Model`} loading="lazy" src={`${productPath}/main-bg_sp.webp`} />
            </picture>

            <picture className="body-squid-game__lineup__model-main-fg">
              <source
                media="(min-width: 768px)"
                srcSet={`${baseImgUrl}/lineup/products/bg-fg_pc.webp`}
              />
              <img
                alt={`${title} Model`}
                loading="lazy"
                src={`${baseImgUrl}/lineup/products/bg-fg_sp.webp`}
              />
            </picture>

            {renderName(id, title)}

            <div className="base-squid-game__container">
              <div data-aos="fade-up">
                <Slider {...mainProductSetting} className="body-squid-game__lineup__model-main-img">
                  {Array.from({ length: 2 }, (_, i) => (
                    <li key={`squid-game__main-product-${i + 1}`}>
                      <picture>
                        <source
                          media="(min-width: 768px)"
                          srcSet={`${productPath}/main-product_pc-${i + 1}.webp`}
                        />
                        <img
                          alt={product.number}
                          src={`${productPath}/main-product_sp-${i + 1}.webp`}
                        />
                      </picture>

                      {i === 0 && (
                        <div className="body-squid-game__lineup__model-main-img__desc">
                          <h4>{product.number}</h4>
                          <p>{product.price}</p>
                        </div>
                      )}

                      {i === 1 && (
                        <p className="body-squid-game__lineup__model-main-desc body-squid-game__lineup__model-main-desc--pc">
                          {desc}
                        </p>
                      )}
                    </li>
                  ))}
                </Slider>
              </div>

              <p className="body-squid-game__lineup__model-main-desc body-squid-game__lineup__model-main-desc--sp">
                {desc}
              </p>

              <Slider
                {...pointSetting}
                className={`body-squid-game__lineup__points body-squid-game__lineup__points--${id}`}
              >
                {points.map((text, i) => (
                  <li
                    key={`${product.number}__point-${i + 1}`}
                    data-aos="fade-left"
                    data-aos-delay={100 * (i + 1)}
                  >
                    <img alt={`POINT ${i + 1}`} src={`${productPath}/point-${i + 1}.webp`} />
                    <div className="body-squid-game__lineup__point-desc">
                      <p
                        className="body-squid-game__lineup__point-text"
                        data-key={`${id}-point-${i + 1}`}
                      >
                        {text}
                      </p>
                      <p className="body-squid-game__lineup__point-order">
                        <span>POINT</span>
                        <span>0</span>
                        <span>{i + 1}</span>
                      </p>
                    </div>
                  </li>
                ))}
              </Slider>
            </div>
          </div>

          <div className="body-squid-game__lineup__products-layout" data-key={id}>
            <div className="body-squid-game__lineup__products-inner">
              <div className="body-squid-game__lineup__products-card" data-aos="fade-up">
                <ul className="body-squid-game__lineup__products-colors">
                  {stateProduct.colors.map((color, index) => (
                    <li key={color} data-color-selected={isSelectedColor(currentKey, index)}>
                      <button
                        data-color={color.toLowerCase().replace(' ', '-')}
                        onClick={() => handleSelectedColor(product.number, index)}
                      />
                    </li>
                  ))}
                </ul>

                <Slider {...setting} ref={ref} className="body-squid-game__lineup__products-slider">
                  {Array.from({ length: limit }, (_, i) => (
                    <div key={`product-squid-game-${i + 1}`}>
                      <img
                        alt={`${product.number} ${currentKey}`}
                        src={`${productPath}/${product.number}_${currentKey}-0${i + 1}.webp`}
                      />
                    </div>
                  ))}
                </Slider>

                <div className="body-squid-game__lineup__products-desc">
                  <img
                    alt="Original cleaning cloth set"
                    loading="lazy"
                    src={`${productPath}/cleaning-cloth-set.webp`}
                  />
                  <div className="body-squid-game__lineup__products-desc__text">
                    <h4>{product.name}</h4>
                    <p>{product.desc}</p>
                  </div>
                </div>

                <div className="body-squid-game__lineup__products-btn body-squid-game__lineup__products-btn--pc">
                  {renderButton(product.number, currentKey)}
                </div>
              </div>
            </div>

            <div className="body-squid-game__lineup__products-btn body-squid-game__lineup__products-btn--sp">
              {renderButton(product.number, currentKey)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="body-squid-game__lineup">
      {LINEUP.slice(0, 6).map((model, index) => renderModel(model, index))}
    </section>
  );
};
